module.exports = __webpack_public_path__ + "img/purple-plus.07baa65b.svg";